export enum RentalsActionTypes {
  API_RESPONSE_SUCCESS = "@@rentals/API_RESPONSE_SUCCESS",
  API_RESPONSE_ERROR = "@@rentals/API_RESPONSE_ERROR",

  GET_RENTALS = "@@rentals/GET_RENTALS",
}
